import React, { Component } from 'react';
import {connect } from 'react-redux';
import {Link} from 'react-router-dom';

import DrawArea from '../step1/DrawArea/index';
import './style.css';
import Plan from "../BuildSteps/BuildsComponent/Plan";
import StepStatus from '../../../components/CarentPageComponents/StepStatus';
import {getParamsOfGrid} from "../../../helpers/getParamsOfGrid";
import {send} from '../../../actions/send';
import {isVisitedFinish} from "../../../actions/isVisitedFinish";
import {sleeveSize} from "../../../constants/constants";
import SendButton from "./SendButton";

class Finish extends Component{
    constructor(props){
        super(props);
        this.state = {
            planA : {
                numberOfCellsWidth : null,
                numberOfCellsHeight : null,
                sizeOfCell : null
            },
            planB : {
                numberOfCellsWidth : null,
                numberOfCellsHeight : null,
                sizeOfCell : null
            },
            planC : {
                numberOfCellsWidth : null,
                numberOfCellsHeight : null,
                sizeOfCell : null
            },
            planD : {
                numberOfCellsWidth : null,
                numberOfCellsHeight : null,
                sizeOfCell : null
            }
        };
    };
    componentDidMount(){
        this.props.isVisitedFinish();
        const dimensions = {
            length : this.props.buildValues.length,
            width : this.props.buildValues.width
        };
        const params = getParamsOfGrid('inner-plan-step-2', dimensions, this.props.buildValues.height);
        this.setState({
            ...params
        });

    }
    send  = (e) => {
        e.preventDefault();
        const data = {
            length : this.props.buildValues.length,
            width : this.props.buildValues.width,
            height: this.props.buildValues.height,
            thickness : this.props.buildValues.wallWidth,
            cover_class : this.props.buildValues.deckelklasse,
            included_cover : this.props.buildValues.deckel ? 1 : 0,
            included_bottom : this.props.buildValues.boden ? 1 : 0,
            email: this.props.buildValues.from_email
        };


        const sleeves = {"A" : [], "B" : [], "C" :[], "D" : []};
        let i = 0;
        for(let key in sleeves){
            sleeves[key] = this.props.buildValuesSides[i].sleeves.map((item) => {

                const size = sleeveSize[item.background];
                let x = Math.round(item.left + size/2);
                let y = Math.round(item.top + size/2);
                return [ size, x, y ];
            });
            i++;
        }
        data.sleeves = sleeves;

        const recesses = {"A" : [], "B" : [], "C" :[], "D" : []};
        for(let i = 0; i < this.props.buildValuesSides[0].lids.length; i++){
            if(this.props.buildValuesSides[0].lids[i].length &&
                this.props.buildValuesSides[0].lids[i].height &&
                this.props.buildValuesSides[0].lids[i].left >=0 &&
                this.props.buildValuesSides[0].lids[i].top >=0){
                recesses["A"].push([
                    this.props.buildValuesSides[0].lids[i].sagex ? 1 : 0,
                    this.props.buildValuesSides[0].lids[i].length,
                    this.props.buildValuesSides[0].lids[i].height,
                    Math.round(this.props.buildValuesSides[0].lids[i].left),
                    Math.round(this.props.buildValuesSides[0].lids[i].top),
                ]);
            }

        }
        for(let i = 0; i < this.props.buildValuesSides[1].lids.length; i++){
            if(this.props.buildValuesSides[1].lids[i].length &&
                this.props.buildValuesSides[1].lids[i].height &&
                this.props.buildValuesSides[1].lids[i].left >=0 &&
                this.props.buildValuesSides[1].lids[i].top >=0){
                recesses["B"].push([
                    this.props.buildValuesSides[1].lids[i].sagex ? 1 : 0,
                    this.props.buildValuesSides[1].lids[i].length,
                    this.props.buildValuesSides[1].lids[i].height,
                    Math.round(this.props.buildValuesSides[1].lids[i].left),
                    Math.round(this.props.buildValuesSides[1].lids[i].top),
                ]);
            }
        }
        for(let i = 0; i < this.props.buildValuesSides[2].lids.length; i++){
            if(this.props.buildValuesSides[2].lids[i].length &&
                this.props.buildValuesSides[2].lids[i].height &&
                this.props.buildValuesSides[2].lids[i].left >=0&&
                this.props.buildValuesSides[2].lids[i].top >=0){
                recesses["C"].push([
                    this.props.buildValuesSides[2].lids[i].sagex ? 1 : 0,
                    this.props.buildValuesSides[2].lids[i].length,
                    this.props.buildValuesSides[2].lids[i].height,
                    Math.round(this.props.buildValuesSides[2].lids[i].left),
                    Math.round(this.props.buildValuesSides[2].lids[i].top),
                ]);
            }
        }
        for(let i = 0; i < this.props.buildValuesSides[3].lids.length; i++){
            if(this.props.buildValuesSides[3].lids[i].length &&
                this.props.buildValuesSides[3].lids[i].height &&
                this.props.buildValuesSides[3].lids[i].left>=0 &&
                this.props.buildValuesSides[3].lids[i].top>=0){
                recesses["D"].push([
                    this.props.buildValuesSides[3].lids[i].sagex ? 1 : 0,
                    this.props.buildValuesSides[3].lids[i].length,
                    this.props.buildValuesSides[3].lids[i].height,
                    Math.round(this.props.buildValuesSides[3].lids[i].left),
                    Math.round(this.props.buildValuesSides[3].lids[i].top),
                ]);
            }
        }
        data.recesses = recesses;
        data.email = this.props.buildValues.email;
        data.dataFromForm = {...this.props.buildValues.dataFromForm}
        send(data);

    };
    render(){

        const dimensions = {
            length : this.props.buildValues.length,
            width : this.props.buildValues.width
        };

       const styleForSectionsHeaders = {
            color: "#ffffff",
            width : "100%",
            paddingBottom: window.innerWidth < 480 ? "20px" : "50px",
            textAlign : "center",
            fontFamily: "Raleway",
            fontWeight: "normal",
            fontStyle: "normal",
            fontStretch: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
            textDecoration : "none",
            display : "block"
       };

        return(
            <main className="finish-step">
                <StepStatus
                    isFinish = {true}
                    withoutHint = {true}
                />
                <div className="plan-finish-step-wrapper" style={{margin: "auto"}}>
                    <h1><Link to = "/step/1" style = {styleForSectionsHeaders}>GRUNDRISS</Link></h1>
                    <div style={{width: "calc( (100vw - 375px)/(1920 - 375) * (689 - 223) + 223px)", margin: "auto"}}>
                        <DrawArea />
                    </div>
                </div>
                <div className="general-checkbox-finish-step">
                    <ul>
                        <li className="additional-option-option-step-1" style = {{width: "300px", margin: "auto"}}>
                            <label htmlFor="" className="additional-options-option-name-step-1">Inklusiv Deckel</label>
                            <div className="wrapper-additional-option-value-step-1">
                                <input
                                    type="checkbox"
                                    className={"additional-options-checkbox-step-1"}
                                    data-input-name = {"boden"}
                                    onChange={this.props.changeInputValue}
                                    checked = {this.props.buildValues.deckel}
                                    readOnly={this.props.buildValues.deckel && !this.props.changeInputValue}
                                />
                            </div>
                        </li>
                        <li className="additional-option-option-step-1" style = {{width: "300px", margin: "auto"}}>
                            <label htmlFor="" className="additional-options-option-name-step-1">Inklusiv Boden</label>
                            <div className="wrapper-additional-option-value-step-1">
                                <input
                                    type="checkbox"
                                    className={"additional-options-checkbox-step-1"}
                                    data-input-name = {"boden"}
                                    onChange={this.props.changeInputValue}
                                    checked = {this.props.buildValues.boden}
                                    readOnly={this.props.buildValues.boden && !this.props.changeInputValue}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="wrapper-side-a-side-b-finish-step">
                    <div className="side-a-finish-step">
                        <h1 className={"side-header"}>
                            <Link to = "/step/2" style = {styleForSectionsHeaders}>ANSICHT A</Link>
                        </h1>
                        <Plan
                            bottom = {"50%"}
                            borderColor = {"black"}
                            height = {this.props.buildValues.height}
                            dataInputName = "height"
                            isInput = {true}
                            areaName = {"planA"}
                            dimensions = {dimensions}
                            buildValues = {this.props.buildValues}
                            currentStep={2}
                            areaDimension = {"length"}
                            numberOfCellsWidth = {this.state["planA"].numberOfCellsWidth}
                            numberOfCellsHeight = {this.state["planA"].numberOfCellsHeight}
                            sizeOfCell = {this.state["planA"].sizeOfCell}
                            isVerticalArrow={true}
                            items = {this.props.buildValuesSides[0].sleeves}
                            lids = {this.props.buildValuesSides[0].lids}
                            withoutResize = {true}
                            withoutDragging = {true}
                            sleeves = {this.props.buildValuesSides[0].sleeves}
                        />
                    </div>
                    <div className="side-b-finish-step">
                        <h1><Link to = "/step/3" style = {styleForSectionsHeaders}>ANSICHT B</Link></h1>
                        <div style = {{width : `calc(${this.state.planB.sizeOfCell * this.state.planB.numberOfCellsWidth}px + 2 * ((100vw - 375px)/(1920 - 375) * (32 - 15) + 15px) + 24px)`, margin: "0 auto"}}>
                            <Plan
                                areaName = {"planB"}
                                dimensions = {dimensions}
                                buildValues = {this.props.buildValues}
                                paddingRight={"16.6%"}
                                areaDimension = {"length"}
                                currentStep={3}
                                numberOfCellsWidth = {this.state["planB"].numberOfCellsWidth}
                                numberOfCellsHeight = {this.state["planB"].numberOfCellsHeight}
                                sizeOfCell = {this.state["planB"].sizeOfCell}
                                lids = {this.props.buildValuesSides[1].lids}
                                items = {this.props.buildValuesSides[1].sleeves}
                                sleeves = {this.props.buildValuesSides[1].sleeves}
                                withoutResize = {true}
                                withoutDragging = {true}
                            />
                        </div>
                    </div>
                </div>

                <div className="wrapper-side-c-side-d-finish-step">
                    <div className="side-c-finish-step">
                        <h1><Link to = "/step/4" style = {styleForSectionsHeaders}>ANSICHT C</Link></h1>
                        <div style = {{width : `calc(${this.state.planC.sizeOfCell * this.state.planC.numberOfCellsWidth}px + 2 * ((100vw - 375px)/(1920 - 375) * (32 - 15) + 15px) + 24px)`, margin: "0 auto"}}>
                            <Plan
                                areaName = {"planC"}
                                dimensions = {dimensions}
                                buildValues = {this.props.buildValues}
                                areaDimension = {"width"}
                                currentStep={4}
                                numberOfCellsWidth = {this.state["planC"].numberOfCellsWidth}
                                numberOfCellsHeight = {this.state["planC"].numberOfCellsHeight}
                                sizeOfCell = {this.state["planC"].sizeOfCell}
                                lids = {this.props.buildValuesSides[2].lids}
                                items = {this.props.buildValuesSides[2].sleeves}
                                sleeves = {this.props.buildValuesSides[2].sleeves}
                                withoutResize = {true}
                                withoutDragging = {true}
                            />
                        </div>
                    </div>
                    <div className="side-d-finish-step">
                        <h1><Link to = "/step/5" style = {styleForSectionsHeaders}>ANSICHT D</Link></h1>
                        <div style = {{width : `calc(${this.state.planD.sizeOfCell * this.state.planD.numberOfCellsWidth}px + 2 * ((100vw - 375px)/(1920 - 375) * (32 - 15) + 15px) + 24px)`, margin: "0 auto"}}>
                            <Plan
                                areaName = {"planD"}
                                dimensions = {dimensions}
                                buildValues = {this.props.buildValues}
                                areaDimension = {"width"}
                                currentStep={5}
                                numberOfCellsWidth = {this.state["planD"].numberOfCellsWidth}
                                numberOfCellsHeight = {this.state["planD"].numberOfCellsHeight}
                                sizeOfCell = {this.state["planD"].sizeOfCell}
                                lids = {this.props.buildValuesSides[3].lids}
                                items = {this.props.buildValuesSides[3].sleeves}
                                sleeves = {this.props.buildValuesSides[3].sleeves}
                                withoutResize = {true}
                                withoutDragging = {true}
                            />
                        </div>
                    </div>
                </div>
                <SendButton clickHandler = {this.send} />
            </main>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        buildValues : state.buildValues,
        buildValuesSides : state.buildValuesSides
    }
};

const mapStateToDispatch ={
    isVisitedFinish
};

export default connect(mapStateToProps, mapStateToDispatch)(Finish)


// WEBPACK FOOTER //
// ./src/containers/steps/FinishStep/index.js